import React from 'react';
import { DjayAvatar, type DjayEmotion } from '../../../mascot';
interface DjayInsightBarProps {
  emotion: DjayEmotion;
  title?: string;
  message: string | React.ReactNode;
  className?: string;
}
export function DjayInsightBar({
  emotion,
  title = "Djay's Inzicht",
  message,
  className = ''
}: DjayInsightBarProps) {
  return <div className={`bg-indigo-50/50 border border-indigo-100 rounded-2xl p-4 flex items-center gap-4 ${className}`} data-id="element-5590">
      <DjayAvatar size="md" emotion={emotion} data-id="element-5591" />
      <div className="flex-1" data-id="element-5592">
        <h3 className="text-sm font-bold text-indigo-900 mb-1" data-id="element-5593">{title}</h3>
        <div className="text-sm text-indigo-700" data-id="element-5594">{message}</div>
      </div>
    </div>;
}